import "vant/es/count-down/style";
import _CountDown from "vant/es/count-down";
import "core-js/modules/es.object.assign.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import dayjs from 'dayjs';
import Drip from 'drip';
import { parseDetailUrl } from '@/utils';
Vue.use(_CountDown);
export default {
  name: 'TicketGrabberStation',
  components: {},
  props: {
    ticketStationData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      projectInfo: {},
      timeType: 0,
      formatTime: '',
      countDownTime: 0 // ms
    };
  },

  computed: {},
  watch: {
    ticketStationData: {
      immediate: true,
      handler: 'initData'
    }
  },
  mounted: function mounted() {
    var dataSeed = this.ticketStationData.dataSeed;
    window.seedAction({
      evt: 'view',
      bid: dataSeed.viewBid,
      custom: Object.assign({}, dataSeed.custom)
    });
  },
  methods: {
    initData: function initData() {
      var projectInfo = Object.assign({}, this.ticketStationData);
      this.projectInfo = projectInfo;

      // 若为待开售的项目，则判断开售时间：
      // 若开售时间未确定，展示“即将开抢”
      // 若开售时间已确定，距离开抢>24h，展示“开抢时间+开抢”，如：“8月10日10:58开抢“
      // 若开售时间已确定，距离开抢<=24h，展示“倒计时”，如：“02:10:58后开抢“
      // 若为已开售的项目：则展示“正在热抢”
      var saleTime = this.projectInfo.saleTime;
      if (saleTime) {
        var preOneDaySaleTime = saleTime - 24 * 60 * 60 * 1000;
        var nowTime = Date.now();
        if (nowTime < saleTime && preOneDaySaleTime <= nowTime) {
          this.timeType = 1;
          this.countDownTime = saleTime - nowTime;
          // 距离开抢<=24h，展示“倒计时”
        } else {
          // 距离开抢>24h，展示“开抢时间+开抢”，
          this.formatTime = dayjs(saleTime).format('MM月DD日 HH:mm 开抢');
          this.timeType = 2;
        }
      }
    },
    goDetailPage: function goDetailPage() {
      var _this$projectInfo = this.projectInfo,
        jumpDetailUrl = _this$projectInfo.jumpDetailUrl,
        performanceId = _this$projectInfo.performanceId,
        tagSeed = _this$projectInfo.tagSeed,
        dataSeed = _this$projectInfo.dataSeed;
      if (tagSeed) {
        window.lxTagReport('c_movie_aq5xt2v5', dataSeed.bid, Object.assign({}, tagSeed));
      }
      if (dataSeed) {
        window.seedAction(dataSeed);
      }
      if (jumpDetailUrl) {
        this.go(parseDetailUrl(jumpDetailUrl), {
          _blank: true
        });
      } else {
        this.go("/detail/".concat(performanceId), {
          _blank: true
        });
      }
    },
    goStationPage: function goStationPage() {
      var performanceId = this.projectInfo.performanceId;
      window.lxTagReport('c_movie_aq5xt2v5', 'b_movie_tan2cp1t_mc', {
        performance_id: performanceId
      });
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_tan2cp1t_mc',
        performance_id: performanceId,
        custom: {
          performance_id: performanceId
        }
      });
      Drip.redirect('/myshow/#/new-calendar?tab=1');
    },
    timeCountDownFinished: function timeCountDownFinished() {
      // 倒计时结束、开售状态设置为已开售，视图ui展示正在热抢
      this.projectInfo.saleStatus = 1;
    },
    padZero: function padZero(num) {
      var targetLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      var str = num + '';
      while (str.length < targetLength) {
        str = '0' + str;
      }
      return str;
    }
  }
};